import { RecalProcessAndGenEntity } from "./RecalProcessAndGenEntity"

export interface RecalProcessAndGenEditCriteria {

    seqNo: number | null,
    oneOffRate: number | null,
    isAssignSeq: boolean,
    isAssignOneOffRate: boolean,
    selectRows: RecalProcessAndGenEntity[],

    [key: string]: string[] | string | boolean | number | Date | null | undefined | any
}

export const EMPTY_RECAL_PROCESS_AND_GEN_EDIT_CRITERIA: RecalProcessAndGenEditCriteria = {
    seqNo: null,
    oneOffRate: null,
    isAssignSeq: false,
    isAssignOneOffRate: false,
    selectRows: [],
}